export default "__VITE_ASSET__DdOCKVKB__"